define((require) => {
    "use strict";

    var ImprovedModel     = require("shared/zbone/ImprovedModel");

    /**
     * Represents a recipient of a share. Used in the share menu when creating a share.
     *
     * <p>A share recipient can either be a registered user, or a new user identified by an email address.</p>
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipient
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            user: null,
            email: "",
            selected: false
        },

        computed: {
            displayName: {
                deps: ["user", "email"],
                value: function(user, email) {
                    return (user && user.get("displayName")) || email || "";
                }
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareRecipient.js